export default __webpack_public_path__ + "img/Hepatopancreas.6c3c3c8e.png";